import React from 'react';
import { Box, Button, Paragraph } from 'grommet';
import { useNavigate } from 'react-router-dom';
import { useErrorBoundary } from 'react-error-boundary';
import PageWrapper from '../../PageWrapper/PageWrapper';
import PageTitle from '../../PageTitle/PageTitle';

export interface ErrorBoundaryFallbackProps {
  onReset?: () => void;
}

const ErrorBoundaryFallback: React.FC<ErrorBoundaryFallbackProps> = ({ onReset }): JSX.Element => {
  const navigate = useNavigate();
  const { resetBoundary } = useErrorBoundary();
  const onClick = (): void => {
    if (onReset) onReset();
    resetBoundary();
    navigate('/');
  };

  return (
    <PageWrapper>
      <PageTitle
        Text="Sorry, but there was an error"
      />
      <Paragraph fill>
        Don't worry, our technicians have been notified.
      </Paragraph>
      <Box>
        <Button
          title="Back to Home Page"
          label="Back to Home Page"
          primary
          onClick={onClick}
        />
      </Box>
    </PageWrapper>
  );
};

ErrorBoundaryFallback.displayName = 'ErrorBoundaryFallback';

export default ErrorBoundaryFallback;
